import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgUserGreenBig = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={58}
    height={47}
    fill="none"
    viewBox="0 0 28 17"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M9.5 9.5c-1.306 0-2.424-.465-3.355-1.395-.93-.93-1.395-2.049-1.395-3.355s.465-2.424 1.395-3.355C7.075.465 8.194 0 9.5 0s2.425.465 3.355 1.395c.93.93 1.395 2.049 1.395 3.355s-.465 2.424-1.395 3.355c-.93.93-2.049 1.395-3.355 1.395ZM0 19v-3.325c0-.673.173-1.291.52-1.856a3.464 3.464 0 0 1 1.38-1.29 17.628 17.628 0 0 1 3.74-1.381 16.337 16.337 0 0 1 3.86-.46c1.306 0 2.593.153 3.86.46a17.63 17.63 0 0 1 3.74 1.38 3.464 3.464 0 0 1 1.38 1.291 3.48 3.48 0 0 1 .52 1.856V19H0Zm2.375-2.375h14.25v-.95a1.155 1.155 0 0 0-.594-1.01 15.476 15.476 0 0 0-3.236-1.202 13.775 13.775 0 0 0-6.59 0 15.479 15.479 0 0 0-3.236 1.203 1.156 1.156 0 0 0-.594 1.009v.95Zm7.125-9.5c.653 0 1.212-.233 1.677-.698a2.287 2.287 0 0 0 .698-1.677c0-.653-.233-1.212-.698-1.677A2.287 2.287 0 0 0 9.5 2.375c-.653 0-1.212.233-1.677.698a2.287 2.287 0 0 0-.698 1.677c0 .653.233 1.212.698 1.677a2.287 2.287 0 0 0 1.677.698Z"
      fill="#00BC82"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserGreenBig);
export default ForwardRef;
